export interface NumericScale { min: number; max: number; step: number; unit: string }
export const HOLD_DELAY_MS = 300;
export const MOTION_INTERVAL_MS = 50;
export const nudgeSteps = ({ unit }: NumericScale): number => unit === '°' || unit === 'm AGL' ? 10 : unit === 'mm' ? 5 : 1;

export function maximumRate({ min, max, step, unit }: NumericScale): number {
  const rate = unit === '°' ? 90 : unit === 'm AGL' ? 2000 : unit === 'mm' ? 180
    : unit === '%' ? 30 : unit === '×' ? .8 : (max - min) / 4;
  return Math.max(step * 4, Math.min(rate, Math.max(step * 4, max - min)));
}

/** Displacement controls speed; release preserves the value and centers the lever. */
export function pushAmount(pixels: number): number {
  const distance = Math.abs(pixels);
  if (distance <= 3) return 0;
  return Math.sign(pixels) * Math.min(1, (distance - 3) / 25);
}

export function pushRate(amount: number, scale: NumericScale): number {
  return Math.sign(amount) * amount * amount * maximumRate(scale);
}

export function holdRate(elapsedMilliseconds: number, scale: NumericScale): number {
  if (elapsedMilliseconds < HOLD_DELAY_MS) return 0;
  const ramp = Math.min(1, (elapsedMilliseconds - HOLD_DELAY_MS) / 1300);
  return maximumRate(scale) * (.04 + .96 * ramp * ramp);
}

export function boundedValue(value: number, scale: NumericScale): number {
  return Number(Math.max(scale.min, Math.min(scale.max, value)).toFixed(6));
}

export function motionValue(value: number, origin: number, scale: NumericScale): number {
  if (value <= scale.min || value >= scale.max) return boundedValue(value, scale);
  return boundedValue(origin + Math.round((value - origin) / scale.step) * scale.step, scale);
}
